import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

// Shop Pay Installments preview — one quiet line beneath a price. Shopify/Affirm
// handle the real financing (and full terms) at checkout; this is on-site
// awareness only, using the "as low as $X/mo" framing:
//
//   >= $150  : "as low as $X/mo"  (price ÷ 12 — the 0% APR / 12-month floor;
//              monthly installments start at $150)
//   $50–$150 : "4 interest-free payments of $X"  (Pay-in-4; monthly isn't
//              offered under $150, so "/mo" wouldn't be truthful here)
//   < $50    : no installment offer — render nothing
//
// "Shop Pay" carries the brand (purple #5A31F4); the rest is muted so the price
// stays the hero. No inline APR text — the real rate (0–36%, set per customer)
// is shown by Shop Pay at checkout.
const MIN_ELIGIBLE = 50;   // Shop Pay Installments minimum (Pay-in-4)
const MONTHLY_MIN = 150;   // monthly installments become available at $150
const MONTHLY_TERM = 12;   // longest term -> the "as low as" monthly floor
const SHOP_PURPLE = '#5A31F4';

const ShopPayInstallments = ({ price, align = 'left', style }) => {

    const amount = parseFloat(price) || 0;
    if(amount < MIN_ELIGIBLE) {
        return null;
    }

    const message = amount >= MONTHLY_MIN
        ? `As low as ${Utils.formatCurrency(amount / MONTHLY_TERM)}/mo`
        : `Or 4 payments of ${Utils.formatCurrency(amount / 4)}`;

    return (
        <div style={{
            ...Appearance.textStyles.caption({ color: Appearance.colors.subText() }),
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap',
            justifyContent: align === 'center' ? 'center' : 'flex-start',
            ...style,
        }}>
            <span>{message} • <span style={{ color: SHOP_PURPLE, fontWeight: 700 }}>{'Shop Pay'}</span></span>
        </div>
    );
};

export default ShopPayInstallments;
